'use client';

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { usePathname } from 'next/navigation';

interface AnimationProviderProps {
  children: React.ReactNode;
}

/**
 * AnimationProvider wraps the app content with AnimatePresence
 * This enables page transition animations throughout the application
 * mode="wait" ensures the exit animation completes before the enter animation starts
 */
export default function AnimationProvider({ children }: AnimationProviderProps) {
  const pathname = usePathname();

  return (
    <AnimatePresence data-component-id="src/components/common/AnimationProvider.tsx:20:4" data-component-path="src/components/common/AnimationProvider.tsx" data-component-line="20" data-component-end-line="24" data-component-file="AnimationProvider.tsx" data-component-name="AnimatePresence" data-component-content="%7B%22elementName%22%3A%22AnimatePresence%22%7D" mode="wait" initial={false}>
      <React.Fragment key={pathname}>
        {children}
      </React.Fragment>
    </AnimatePresence>
  );
}
